import { forwardRef, type Ref, type SVGProps } from "react";
const IconHomesOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.96 13.01a2.2 2.2 0 0 0-.25-.62 2 2 0 0 0-.34-.43l-9-8.42a2 2 0 0 0-2.74 0l-.17.16 7.27 6.8a3.6 3.6 0 0 1 .69.87 4 4 0 0 1 .5 1.23 4.5 4.5 0 0 1 .08.82V29h2a1.9 1.9 0 0 0 1.28-.48 1.7 1.7 0 0 0 .27-.27 2 2 0 0 0 .41-.85A4 4 0 0 0 30 27V13.42a2 2 0 0 0-.04-.41"
    />
    <path
      fill="currentColor"
      d="M23.96 13.01a2.2 2.2 0 0 0-.25-.62 2 2 0 0 0-.34-.43l-9-8.42a2 2 0 0 0-2.74 0l-9 8.42a1.9 1.9 0 0 0-.46.66 2 2 0 0 0-.17.8V27a1.8 1.8 0 0 0 .04.4 1.94 1.94 0 0 0 .55 1.01 1.8 1.8 0 0 0 .63.43A2 2 0 0 0 4 29h18a1.9 1.9 0 0 0 1.28-.48 1.7 1.7 0 0 0 .27-.27 2 2 0 0 0 .41-.85A4 4 0 0 0 24 27V13.42a2 2 0 0 0-.04-.41M11 27v-8h4v8zm11-.09-.02.09H17v-8a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v7.99H4V13.43l.01-.02 8.98-8.4A.01.01 0 0 1 13 5l8.98 8.4.01.01a.04.04 0 0 0 .01.02z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHomesOutlineSVG);
ForwardRef.displayName = "IconHomesOutline";
export { ForwardRef as IconHomesOutline };
